import { Button, Tooltip } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

/**
 * Folds the column beside the map away, and brings it back.
 *
 * This existed only inside the assistant's header, which made "see just the
 * map" something you could reach only by opening a chat you did not want —
 * and on the multi-day screen not at all. It belongs to the map, so it sits
 * on the map.
 *
 * Top right, because every other corner is taken: the zoom and compass own
 * the top left, the route's own figures the bottom left, and the out-and-back
 * key the bottom right.
 *
 * Wide screens only. Below the breakpoint the two do not share the screen in
 * the first place — the map replaces the column rather than sitting beside
 * it — so there is nothing here to fold.
 */
export function MapOnlyToggle({
  open, onToggle, whatIsBeside = 'the form',
}: {
  /** Whether the column is currently showing. */
  open: boolean;
  onToggle: () => void;
  /** What comes back, named in the button rather than left to be guessed. */
  whatIsBeside?: string;
}) {
  return (
    <Tooltip title={open ? 'Hide everything but the map' : `Bring back ${whatIsBeside}`}>
      <Button
        data-tour="map-only"
        variant="contained"
        size="small"
        color="inherit"
        startIcon={open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        onClick={onToggle}
        sx={{
          display: { xs: 'none', md: 'inline-flex' },
          position: 'absolute',
          top: 10, right: 10,
          zIndex: 6,
          boxShadow: 3,
          bgcolor: 'background.paper',
          '&:hover': { bgcolor: 'background.paper' },
        }}
      >
        {open ? 'Map only' : whatIsBeside}
      </Button>
    </Tooltip>
  );
}
